export const aboutTextP1 =
    "We are a group of waiters and developers that have developed a gifting and rating platform that any e-menu company can integrate 🙃"

export const aboutTextP2 =
    "Our Mission is to help us (waiters) improve our perfomance by leaving a comment or brighten our day with a gift 🥳"

export const aboutTextP3 =
    "You can trust us in that we speak for all waiters when we say we love gifts 🥰"
